import gql from 'graphql-tag';

const GET_VALIDATE_INVENTORY_REQUEST_SUBMIT = gql`
  query validateInventoryRequestSubmit(
    $caseId: String
    $caseExternalId: String
    $accountId: String
    $salesRepId: String
    $serviceLevel: String
    $needByDate: Date
    $eventType: String
    $lineItems: [SubmitInventoryRequestLineItems]
  ) {
    validateInventoryRequestSubmit(
      caseId: $caseId
      caseExternalId: $caseExternalId
      accountId: $accountId
      salesRepId: $salesRepId
      serviceLevel: $serviceLevel
      needByDate: $needByDate
      eventType: $eventType
      lineItems: $lineItems
    ) {
      valid
      reasons {
        code
        message
      }
      isOpsApprovalRequired
      is3plOpsApprovalRequired
    }
  }
`;

export default GET_VALIDATE_INVENTORY_REQUEST_SUBMIT;
